/* fb-chrome.js — FreshBox header behaviour.
   Mobile off-canvas drawer (open/close + single-open accordion) and the
   mobile search-row toggle. Desktop hover/mega-nav is pure CSS (fb-nav.css). */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var drawer = document.querySelector('[data-fbd]');
  var scrim  = document.querySelector('[data-fbd-scrim]');

  function openDrawer() {
    if (!drawer) return;
    if (scrim) { scrim.hidden = false; }
    // force reflow so the transition runs from the hidden state
    if (scrim) { void scrim.offsetWidth; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-open');
      setTimeout(function () { scrim.hidden = true; }, 320);
    }
    document.documentElement.style.overflow = '';
  }

  // hamburger(s) open the drawer
  header.querySelectorAll('.site-header-menu-toggle, [data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  if (scrim) scrim.addEventListener('click', closeDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-fbd-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    // single-open accordion
    drawer.querySelectorAll('[data-fbd-toggle]').forEach(function (head) {
      head.addEventListener('click', function () {
        var cat = head.closest('[data-fbd-cat]');
        if (!cat) return;
        var isOpen = cat.classList.contains('is-open');
        drawer.querySelectorAll('[data-fbd-cat].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var h = o.querySelector('[data-fbd-toggle]');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) { cat.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  // mobile search row toggle
  var searchInput = header.querySelector('[data-fbsearch-input]');
  function toggleSearch() {
    var open = header.classList.toggle('mobile-search-open');
    var main = header.querySelector('.site-header-main');
    if (main) main.classList.toggle('mobile-search-open', open);
    if (open && searchInput) { setTimeout(function () { searchInput.focus(); }, 60); }
  }
  header.querySelectorAll('.site-header-mobile-search-button, [data-mobile-search-button]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); toggleSearch(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      header.classList.remove('mobile-search-open');
      var main = header.querySelector('.site-header-main');
      if (main) main.classList.remove('mobile-search-open');
    }
  });

  /* Live cart-count bubble. Empire used to keep this in sync via its StaticHeader
     class, but we detached the header from Empire's section system, so we refresh
     it ourselves: read /cart.js after any cart mutation and on Rebuy cart events.
     The bubble is drawn by `.site-header-cart--count::after { content: attr(data-header-cart-count) }`. */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = header.querySelector('.site-header-cart--count');
        if (!el) return;
        var n = (c && c.item_count) || 0;
        el.setAttribute('data-header-cart-count', n > 0 ? n : '');
        el.classList.toggle('visible', n > 0);
      })
      .catch(function () {});
  }
  // refresh after cart mutations (passthrough wrapper — only adds a side effect)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      return _fetch.apply(this, arguments).then(function (res) {
        try { if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) setTimeout(refreshCartCount, 150); } catch (e) {}
        return res;
      });
    };
  }
  ['rebuy:cart.change', 'rebuy:smartcart.ready', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, refreshCartCount);
  });

  // ---- logged-in account dropdown (icon + dot → menu) ----
  var acct = header.querySelector('[data-fb-acct]');
  if (acct) {
    var acctToggle = acct.querySelector('[data-fb-acct-toggle]');
    var acctMenu = acct.querySelector('[data-fb-acct-menu]');
    var setAcct = function (open) {
      acctMenu.hidden = !open;
      acctToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    acctToggle.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      setAcct(acctMenu.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!acct.contains(e.target)) setAcct(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setAcct(false);
    });
  }
})();
